/**
 * Main Layout Component
 * Provides the main application layout with sidebar and topbar
 */

import React from 'react';
import { Box, Toolbar } from '@mui/material';
import { useStore } from '../store/store';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Footer from './Footer';

const DRAWER_WIDTH = 280;

function MainLayout({ children }) {
  const sidebarOpen = useStore((state) => state.sidebarOpen);

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Top Bar */}
      <TopBar />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: { sm: `calc(100% - ${sidebarOpen ? DRAWER_WIDTH : 0}px)` },
          transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          overflow: 'auto',
          backgroundColor: 'background.default',
          minHeight: '100vh',
          // Optional: Add subtle background pattern from Positive Zero
          // backgroundImage: `url(${BRANDING.images.dashboardBackground})`,
          // backgroundSize: 'cover',
          // backgroundAttachment: 'fixed',
        }}
      >
        <Toolbar /> {/* Spacer for fixed AppBar */}
        <Box sx={{ flex: 1, p: { xs: 3, sm: 4, md: 6 }, maxWidth: '1200px', mx: 'auto', width: '100%' }}>
          {children}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
}

export default MainLayout;

